import { render, staticRenderFns } from "./SchemaSelectConfig.vue?vue&type=template&id=019cac66&scoped=true"
import script from "./SchemaSelectConfig.vue?vue&type=script&lang=js"
export * from "./SchemaSelectConfig.vue?vue&type=script&lang=js"
import style0 from "./SchemaSelectConfig.vue?vue&type=style&index=0&id=019cac66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019cac66",
  null
  
)

export default component.exports